import type { ReactNode } from 'react';

type Props = {
  label: ReactNode;
  hint?: ReactNode;
  error?: ReactNode;
  children: ReactNode;
  /** 标签是否必填（视觉提示 *） */
  required?: boolean;
};

export function Field({ label, hint, error, children, required }: Props) {
  return (
    <div className="field">
      <label className="field-label">
        {label}{required && <span className="field-req">*</span>}
      </label>
      {children}
      {error
        ? <div className="field-err">{error}</div>
        : hint ? <div className="field-hint">{hint}</div> : null
      }
    </div>
  );
}
